import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { SettingsService } from '../../../../../services/settings.service';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'dropbox-panel',
    templateUrl: './dropbox.panel.html',
    styleUrls: ['./dropbox.panel.css']
})
export class DrobBoxPanel extends BaseMediaSourcePanel {

    get RedirectUrl(): string {
        const ret = SettingsService.API_BASE_URL.getValue() + 'config/api/media/oauth/authorizedropbox';
        this.MediaSource.RedirectUrl = ret;
        this.MediaSource.Private = true; 
        return ret;
    }

    set RedirectUrl(val) {
        if (val != this.MediaSource.RedirectUrl) {
            this.MediaSource.RedirectUrl = val;
        }
    }

    authenticate(): void {
        const authstring = 'https://www.dropbox.com/oauth2/authorize?client_id=' + this.MediaSource.ClientId + '&token_access_type=offline&response_type=code&redirect_uri=' + this.MediaSource.RedirectUrl + '&state=' + this.MediaSource.SID;
        window.open(authstring, '_blank');
    }

    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: DrobBoxPanel,
            MediaType: '4b1291fc-a6e4-458f-b00e-0e1be71eb90f'
        };
    }
}
